<script>
import DonationView from "@/javascript/views/clientDashboard/donations/DonationView.vue";
import DonationsIndex from "@/javascript/views/clientDashboard/donations/DonationsIndex.vue";
import {useRoute, useRouter} from "vue-router";
import {useDonationStore} from "@/javascript/stores/donation";
import {useSubscriptionStore} from "../../../stores/subscription";
import SubscriptionView from "./SubscriptionView.vue";

export default {
  name: "DonationsPanel",
  components: {SubscriptionView, DonationsIndex, DonationView},
  setup() {

    const router = useRouter();
    const route = useRoute();
    const donationStore = useDonationStore();
    const subscriptionStore = useSubscriptionStore();

    return {
      route,
      router,
      donationStore,
      subscriptionStore
    };
  },
  data() {
    return {
      showOfflineModal: false
    };
  },
  computed: {
    donationId() {
      return this.route.params.id;
    },
    loading() {
      return this.donationStore.loading;
    },
  },
  watch: {
    'donationStore.organizationId'() {
      this.donationStore.loadData();
    },
    'subscriptionStore.organizationId'() {
      this.subscriptionStore.loadData();
    }
  },
  mounted() {
    this.donationStore.loadData();
    this.subscriptionStore.loadData();
  },
};
</script>

<template>
  <div v-if="donationId && route.params.panel === 'gifts'">
    <donation-view />
  </div>
  <div v-else-if="donationId && route.params.panel === 'recurring-gifts'">
    <subscription-view />
  </div>
  <div v-else>
    <donations-index />
  </div>
</template>

<style scoped lang="scss">
th {
  width: 25%;
  font-size: 10px;
  font-weight: normal;
  text-align: left;
  text-transform: uppercase;
  @apply text-slate-500;
  @apply px-2;
  @apply py-2;
}

td {
  width: 25%;
  font-size: 12px;
  @apply px-2;
  @apply py-4;
}

tr:hover {
  color: darkcyan;
}

</style>
